import {pushEdapEvent} from '../../utils/edap';

export const ACTION_LOCATION = 'property-types-module';

export function pushHandlerClickData(propertyType, index) {
    const eventOptions = {
        actionlocation: ACTION_LOCATION,
        eventrefinements: `${propertyType},position:${index}`,
    };

    const fastPathEventOptions = {
        action_location: ACTION_LOCATION,
        event_refinement: `${propertyType},position:${index}`,
    };

    return () => {
        pushEdapEvent('search.link.click', eventOptions);
        pushEdapEvent('content_tile.selected', fastPathEventOptions);
    };
}

export const pushHandleNextData = () => {
    const edapData = {
        actionlocation: ACTION_LOCATION,
    };

    pushEdapEvent('nav.next.click', edapData);

    pushEdapEvent('ux.cards_visible.adjusted', {
        action_location: ACTION_LOCATION,
        event_action: 'next arrow clicked',
    });
};

export const pushHandlePrevData = () => {
    const edapData = {
        actionlocation: ACTION_LOCATION,
    };

    pushEdapEvent('nav.previous.click', edapData);

    pushEdapEvent('ux.cards_visible.adjusted', {
        action_location: ACTION_LOCATION,
        event_action: 'previous arrow clicked',
    });
};
